import videojs from "video.js/dist/video";
import 'video.js/dist/video-js.css';
import 'videojs-youtube/dist/Youtube.js';
var options = {
    controls: true,
    preload: 'auto',
    autoSetup: false,
    fluid: true,
    responsive: true
};
$(function () {
    $("video").each(function () {
        var element = $(this);
        videojs(element[0], options, function onPlayerReady() { });
    });
});
